import { Check } from "lucide-react";
import UiButton from "@/UI-Components/Buttons/UiButton";
import useStepper from "./hooks/useStepper";
import { useEffect } from "react";
import * as Icons from "lucide-react";
import { LucideIcon } from "lucide-react";

const AgentStepper = () => {
  const {
    states: { setJourneyStep, totalSteps },
    services: { getAllAgentMenu },
    routing: { navigate },
  } = useStepper();

  useEffect(() => {
    if (getAllAgentMenu?.data?.data) {
      const steps = getAllAgentMenu?.data?.data.map((each, idx) => ({
        id: each?.id,
        label: each?.label,
        path: each?.path,
        icon: each?.icon,
        isAccessible: true,
        isCompleted: true,
      }));
      setJourneyStep(steps || []);
    }
  }, [getAllAgentMenu?.data?.data]);

  return (
    <div className="h-[calc(100%-50px)] overflow-y-auto overflow-x-hidden hide-scroll">
      <div className="p-2 flex flex-col">
        {totalSteps?.map((step, index) => {
          const IconComponent = Icons[
            step.icon as keyof typeof Icons
          ] as LucideIcon;

          return (
            <div key={step.id} className="flex flex-col items-center ">
              <div
                className="flex items-center w-full"
                onClick={() => {
                  if (step?.isCompleted || step?.isAccessible) {
                    navigate(`/agent${step?.path}`);
                  }
                }}
              >
                <UiButton
                  buttonType={step?.isAccessible ? "primary" : "tertiary"}
                  disabled={!step?.isAccessible}
                  className="w-10 h-10 rounded-full bg-lightGray"
                  icon={
                    step?.isCompleted ? (
                      <Check className="size-5" />
                    ) : IconComponent ? (
                      <IconComponent className="size-5 font-bold" />
                    ) : null
                  }
                />

                <UiButton
                  buttonType="tertiary"
                  disabled={!step?.isAccessible}
                  text={step.label}
                  className={`ml-4 text-base font-semibold ${
                    step?.isAccessible ? "text-primary" : "text-body"
                  }`}
                />
              </div>

              {index < totalSteps.length - 1 && (
                <div className="w-0.5 h-6 my-1 rounded-full bg-gray-300 dark:bg-gray-700 relative -left-18 overflow-hidden">
                  {step?.isAccessible && (
                    <div className="w-full h-full bg-gradient-to-r from-primary to-primary" />
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AgentStepper;
